import axios from "axios";
const baseurl = process.env.REACT_APP_API_URL;

export const uploadBooking = async (
  contactInformation,
  businessInformation,
  franchisePreferences,
  additionalInformation,
  declaration
) => {
  const response = await axios({
    method: "post",
    url: baseurl + `/franchiseApplication`,
    data: {
      contactInformation: contactInformation,
      businessInformation: businessInformation,
      franchisePreferences: franchisePreferences,
      additionalInformation: additionalInformation,
      declaration: declaration,
    },
  });
  return response.data;
};
